//username validation
export const VALIDATE_USERNAME_REQUEST = "VALIDATE_USERNAME_REQUEST";
export const VALIDATE_USERNAME_RECEIVE = "VALIDATE_USERNAME_RECEIVE";
export const VALIDATE_USERNAME_FAILURE = "VALIDATE_USERNAME_FAILURE";
export const RESET_USERNAME = "RESET_USERNAME";

//register
export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const REGISTER_RECEIVE = "REGISTER_RECEIVE";
export const REGISTER_FAILURE = "REGISTER_FAILURE";
export const RESET_REGISTER= "RESET_REGISTER";

//two factor authentication
export const TWO_FACTOR_AUTH_REQUEST = "TWO_FACTOR_AUTH_REQUEST"
export const TWO_FACTOR_AUTH_RECEIVE = "TWO_FACTOR_AUTH_RECEIVE"
export const TWO_FACTOR_AUTH_FAILURE = "TWO_FACTOR_AUTH_FAILURE"
export const RESET_TWO_FACTOR_AUTH = "RESET_TWO_FACTOR_AUTH"

//two factor authentication verify otp
export const TWO_FACTOR_AUTH_VERIFY_OTP_REQUEST = "TWO_FACTOR_AUTH_VERIFY_OTP_REQUEST"
export const TWO_FACTOR_AUTH_VERIFY_OTP_RECEIVE = "TWO_FACTOR_AUTH_VERIFY_OTP_RECEIVE"
export const TWO_FACTOR_AUTH_VERIFY_OTP_FAILURE = "TWO_FACTOR_AUTH_VERIFY_OTP_FAILURE"
export const RESET_TWO_FACTOR_AUTH_VERIFY_OTP = "RESET_TWO_FACTOR_AUTH_VERIFY_OTP"

//sign in
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_RECEIVE = "LOGIN_RECEIVE";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const RESET_LOGIN = "RESET_LOGIN";

//forgot password
export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_RECEIVE = "FORGOT_PASSWORD_RECEIVE";
export const FORGOT_PASSWORD_FAILURE = "FORGOT_PASSWORD_FAILURE";
export const RESET_FORGOT_PASSWORD = "RESET_FORGOT_PASSWORD";

//user details
export const USER_DETAILS_REQUEST = "USER_DETAILS_REQUEST";
export const USER_DETAILS_RECEIVE = "USER_DETAILS_RECEIVE";
export const USER_DETAILS_FAILURE = "USER_DETAILS_FAILURE";
export const RESET_USER_DETAILS = "RESET_USER_DETAILS";


//Change Password
export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_RECEIVE = "CHANGE_PASSWORD_RECEIVE";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";
export const RESET_CHANGE_PASSWORD = "RESET_CHANGE_PASSWORD";


//Change Email
export const CHANGE_EMAIL_REQUEST = "CHANGE_EMAIL_REQUEST";
export const CHANGE_EMAIL_RECEIVE = "CHANGE_EMAIL_RECEIVE";
export const CHANGE_EMAIL_FAILURE = "CHANGE_EMAIL_FAILURE";
export const RESET_CHANGE_EMAIL = "RESET_CHANGE_EMAIL";

//Update Profile picture
export const UPLOAD_PROFILE_PICTURE_REQUEST = "UPLOAD_PROFILE_PICTURE_REQUEST";
export const UPLOAD_PROFILE_PICTURE_RECEIVE = "UPLOAD_PROFILE_PICTURE_RECEIVE";
export const UPLOAD_PROFILE_PICTURE_FAILURE = "UPLOAD_PROFILE_PICTURE_FAILURE";
export const RESET_UPLOAD_PROFILE_PICTURE= "RESET_UPLOAD_PROFILE_PICTURE";

//YOTI Integration
export const YOTI_INTEGRATION_REQUEST = "YOTI_INTEGRATION_REQUEST";
export const YOTI_INTEGRATION_RECEIVE = "YOTI_INTEGRATION_RECEIVE";
export const YOTI_INTEGRATION_FAILURE = "YOTI_INTEGRATION_FAILURE";
export const RESET_YOTI_INTEGRATION = "RESET_YOTI_INTEGRATION";

//Validate Promocde
export const VALIDATE_PROMOCODE_REQUEST = "VALIDATE_PROMOCODE_REQUEST";
export const VALIDATE_PROMOCODE_RECEIVE = "VALIDATE_PROMOCODE_RECEIVE";
export const VALIDATE_PROMOCODE_FAILURE = "VALIDATE_PROMOCODE_FAILURE";
export const RESET_PROMOCODE = "RESET_PROMOCODE";